<template>
<div>
  <!--file loading modal-->
  <b-modal v-model="showLoadingModal" :width="300" animation="zoom-out" :can-cancel="false">
    <div class="loading-modal">

      <div class="card-content" style="padding-top: 30px">
        <img :src="require('@/assets/gifs/docUpload.gif')" alt="document-upload">
      </div>

    </div>
  </b-modal>
</div>
</template>

<script>

export default {

  name:'FileLoadingComp',



  components:{

  },

  data() {

    return {
      showLoadingModal:true

    }
  },

  methods:{

  },

  mounted() {


  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}

.loading-modal{
  border-radius: 20px;
  background-color: white;
  height: 100%;
}




</style>
